import { useImmer } from "use-immer";
import { useEffect } from "react";
import DayOfWeekCheckboxes from "../DayOfWeekCheckboxes";
import ApiConnector from "../../connector/ApiConnector";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const handleAnalyzeNow = async () => {
    try {
      await ApiConnector.triggerRuleImpactUpdate();
      alert("Rule Impact Analysis job has been enqueued. The dashboard will update automatically when done.");
    } catch (e) {
      alert("Failed to trigger analysis: " + e.message);
    }
  };

  return (
    <article>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Update on days</td>
            <td>
              <DayOfWeekCheckboxes
                dayOfWeekArray={data.updateAtDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtDays = e;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Update on time [CET]</td>
            <td>
              <input
                type="time"
                value={data.updateAtTime}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtTime = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup min [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMin ?? ""}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMin = e.target.value === "" ? null : Number(e.target.value);
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup max [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMax ?? ""}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMax = e.target.value === "" ? null : Number(e.target.value);
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Manual trigger</td>
            <td>
              <button onClick={handleAnalyzeNow}>Analyze now</button>
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  );
};

export default Component;
